import { saveAs } from "file-saver";
import Range from "exceljs/lib/doc/range";

const ExcelJS = require("exceljs/dist/exceljs");

export default class ExcelBook {
  constructor(worksheet) {
    this.workbook = new ExcelJS.Workbook();
    this.worksheet = this.workbook.addWorksheet(worksheet, {
      pageSetup: {
        paperSize: undefined,
        orientation: "landscape",
        margins: {
          left: 0.39,
          right: 0.39,
          top: 0.39,
          bottom: 0.39,
          header: 0.3,
          footer: 0.3,
        },
      },
    });
    this.worksheet.views = [
      {
        showGridLines: false, 
      },
    ];
  }

  getWorksheet(name) {
    return this.workbook.getWorksheet(name);
  }
  createNewSheet(sheetName) {
    this.worksheet = this.workbook.addWorksheet(sheetName);
  }
  addColumns({ columns, ws, inicio }) {
    ws.columns = columns;
    for (let i = 1; i <= columns.length; i++)
      ws.getRow(1).getCell(i).value = "";
    const colsValues = Object.values(columns.map((idCol) => idCol.header));
    ws.getRow(inicio).values = colsValues;
  }
  createLogo({ ws, wb, image }) {
    const width = 180;
    const height = 50;
    const colid = 0;
    const rowid = 0;
    const imageLogo = wb.addImage({
      base64: image,
      extension: "JPG",
    });
    if (image !== "") {
      ws.addImage(imageLogo, {
        tl: { col: colid, row: rowid },
        ext: { width: width, height: height },
      });
    }
  }
  addRows({ rows, ws }) {
    ws.addRows(rows);
  }
  getLastRow({ ws }) {
    const { lastRow } = ws;
    return lastRow.number;
  }
  addValueToCell({ ref, value, ws }) {
    const cell = ws.getCell(`${ref}`);
    cell.value = value;
  }
  mergeCells({ desde, hasta, ws }) {
    ws.mergeCells(`${desde}:${hasta}`);
  }
  unMergeCells({ desde, hasta, ws }) {
    ws.unMergeCells(`${desde}:${hasta}`);
  }
  rangoFechaAvance({ data }) {
    return data?.map((row) => ({
      Fecha_1: row.Fecha_1,
      Fecha_2: row.Fecha_2,
    }));
  }
  applyFillFormula({ cell, formula, ws }) {
    ws.fillFormula(`${cell}`, `${formula}`);
  }
  applySingleFormula({ cell, formula, ws }) {
    ws.getCell(cell).value = { formula: formula };
  }
  searchCell({ ws, text }) {
    let celdaValue = null;
    ws.eachRow((row, rowNumber) => {
      row.eachCell((cell) => {
        if (cell.value === text)
          celdaValue = rowNumber;
      });
    });
    return celdaValue;
  }
  porctRange({
    desde,
    hasta,
    ws,
    sizeFont,
    colorFont = "ff000000",
    isBold = false,
    aling = "center",
  }) {
    const style = { numFmt: "0%;[Red]-0%; 0%" };
    //'"£"#,##0.00;[Red]\-"£"#,##0.00'; "0%"
    const alingtext = {
      horizontal: aling,
    };

    const fontCell = {
      size: sizeFont,
      color: { argb: colorFont },
      bold: isBold,
    };
    const range = new Range(desde, hasta);
    range.forEachAddress((address) => {
      const cell = ws.getCell(address);
      cell.style = { ...style };
      cell.alignment = {
        ...alingtext,
      };
      cell.font = {
        ...fontCell,
      };
    });
  }
  numberRange({
    desde,
    hasta,
    ws,
    sizeFont,
    colorFont = "ff000000",
    isBold = false,
    aling = "right",
  }) {
 
    const style = { numFmt: "#,##0.00;[Red]-#,##0;-" };
    //'"£"#,##0.00;[Red]\-"£"#,##0.00'; "0%"
    const alingtext = {
      horizontal: aling,
    };

    const fontCell = {
      size: sizeFont,
      color: { argb: colorFont },
      bold: isBold,
    };
    const range = new Range(desde, hasta);
    range.forEachAddress((address) => {
      const cell = ws.getCell(address);
      cell.style = { ...style };
      cell.alignment = {
        ...alingtext,
      };
      cell.font = {
        ...fontCell,
      };
    });
  }
  stripedCell({
    desde,
    hasta,
    worksheet,
    isBold,
    sizeFont = 12,
    colorBorder = "ff9bc2e6",
    colorPar = "ffddebf7",
    colorNoPar = "FFFFFFFF",
  }) {
    const range = new Range(desde, hasta);
    const colorRow = ({ num }) => {
      if (num % 2 == 0) return colorPar;
      return colorNoPar;
    };
    const formatCol = {
      size: sizeFont,
      bold: isBold,
    };
    range.forEachAddress((address, key) => {
      const cell = worksheet.getCell(address);

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: colorRow({ num: key }) },
      };
      cell.border = {
        bottom: { style: "thin", color: { argb: colorBorder } },
        top: { style: "thin", color: { argb: colorBorder } },
        left: { style: "thin", color: { argb: colorBorder } },
        right: { style: "thin", color: { argb: colorBorder } },
      };
      cell.font = {
        ...formatCol,
      };
    });
  }
  formatTable({
    desde,
    hasta,
    worksheet,
    nbalignment,
    sizeFont,
    colorFont,
    isBold,
    borderBottom,
    borderLeft,
    borderTop,
    borderRight,
    wrap = false,
    borderColor = "ff9bc2e6",
    valignment = "middle",
    fgColor,
  }) {
    const range = new Range(desde, hasta);
    range.forEachAddress((address) => {
      const cell = worksheet.getCell(address);

      cell.alignment = {
        horizontal: nbalignment,
        vertical: valignment,
        wrapText: wrap,
      };

      cell.font = {
        bold: isBold,
        size: sizeFont,
        color: { argb: colorFont },
      };
      cell.border = {
        bottom: { style: borderBottom, color: { argb: borderColor } },
        left: { style: borderLeft, color: { argb: borderColor } },
        right: { style: borderRight, color: { argb: borderColor } },
        top: { style: borderTop, color: { argb: borderColor } },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: fgColor },
      };
      // if (numFormat)
    });
  }
  formatBorder({
    desde,
    hasta,
    worksheet,
    borderBottom = "thin",
    borderLeft = "thin",
    borderTop = "thin",
    borderRight = "thin",
    borderColor = "ff000000",
  }) {
    const range = new Range(desde, hasta);
    range.forEachAddress((address) => {
      const cell = worksheet.getCell(address);
      cell.font = {
        bold: false,
        size: 11,
      };
      cell.border = {
        bottom: { style: borderBottom, color: { argb: borderColor } },
        left: { style: borderLeft, color: { argb: borderColor } },
        right: { style: borderRight, color: { argb: borderColor } },
        top: { style: borderTop, color: { argb: borderColor } },
      };
    });
  }

  applyConditionalFormat({ ref, formuleArr, formatStyle, borderStyle, ws }) {
    ws.addConditionalFormatting({
      ref: ref,
      rules: [
        {
          type: "expression",
          formulae: formuleArr[0],
          style: {
            font: { color: { argb: "fffdfdfd" }, bold: true },
            border: borderStyle,
            fill: formatStyle[0],
          },
        },
        {
          type: "expression",
          formulae: formuleArr[1],
          style: {
            font: { color: { argb: "fffdfdfd" }, bold: true },
            border: borderStyle,
            fill: formatStyle[1],
          },
        },
        {
          type: "expression",
          formulae: formuleArr[2],
          style: {
            font: { color: { argb: "fffdfdfd" }, bold: true },
            border: borderStyle,
            fill: formatStyle[2],
          },
        },
      ],
    });
  }
  formatStyle({ ws, range, style }) {
    ws.getCell(range).style = style;
  }
  downloadFile(fileName) {
    this.workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `${fileName}.xlsx`
      );
    });
  }
}
